export enum InfoBoxPositionEnum {
  Top = 'top',
  Bottom = 'bottom',
  AboveEntireField = 'aboveEntireField',
}
